// Route-hero image + price resolvers — shared between the React SPA
// (src/components/App.jsx) and the SSR template (src/pages/[...slug].astro)
// so both resolve the SAME image URLs / price-min from the SAME code (zero
// drift). Stage 1 of the route-LCP project: these were inline in App.jsx and
// closed over App-internal runtime globals (DESTS, SEO_ROUTES) + the static
// IMG map; they are extracted here as PURE functions that take the runtime
// data as parameters. App.jsx passes its CMS-built DESTS/SEO_ROUTES; the SSR
// template will pass its Sanity-fetched equivalents. No behaviour change — the
// bodies are byte-for-byte the originals, only the free variables became args.
//
// Server-importable: pure string/array ops, no React, no browser API.

// Hardcoded Unsplash fallback map (moved verbatim from App.jsx). Priority
// chain per render: Sanity field FIRST -> IMG.* Unsplash fallback -> generic.
export const IMG = {
  hero:        "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=1800&q=85&auto=format&fit=crop",
  mykonos:     "https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?w=800&q=80&auto=format&fit=crop",
  santorini:   "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=800&q=80&auto=format&fit=crop",
  athens:      "https://images.unsplash.com/photo-1555993539-1732b0258235?w=800&q=80&auto=format&fit=crop",
  paros:       "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=800&q=80&auto=format&fit=crop",
  corfu:       "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=800&q=80&auto=format&fit=crop",
  ios:         "https://images.unsplash.com/photo-1597466599360-3b9775841aec?w=800&q=80&auto=format&fit=crop",
  rhodes:      "https://images.unsplash.com/photo-1623016216287-a3b50d6b0fca?w=800&q=80&auto=format&fit=crop",
  portoHeli:   "https://images.unsplash.com/photo-1534447677768-be436bb09401?w=800&q=80&auto=format&fit=crop",
  tinos:       "https://images.unsplash.com/photo-1555993539-1732b0258235?w=800&q=80&auto=format&fit=crop",
  sifnos:      "https://images.unsplash.com/photo-1504512485720-7d83a16ee930?w=800&q=80&auto=format&fit=crop",
  milos:       "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=800&q=80&auto=format&fit=crop",
  naxos:       "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=800&q=80&auto=format&fit=crop",
  heliAir:     "https://images.unsplash.com/photo-1540962351504-03099e0a754b?w=1800&q=85&auto=format&fit=crop",
  heliCockpit: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=900&q=80&auto=format&fit=crop",
  heliLand:    "https://images.unsplash.com/photo-1569154941061-e231b4725ef1?w=900&q=80&auto=format&fit=crop",
  yacht:       "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=800&q=80&auto=format&fit=crop",
  luxury:      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80&auto=format&fit=crop",
  island:      "https://images.unsplash.com/photo-1504512485720-7d83a16ee930?w=800&q=80&auto=format&fit=crop",
  heli1:       null,
  heli2:       null,
  heli3:       null,
  heli4:       null,
  blog1:       "https://images.unsplash.com/photo-1504512485720-7d83a16ee930?w=600&q=80&auto=format&fit=crop",
  blog2:       "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=600&q=80&auto=format&fit=crop",
  blog3:       "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=600&q=80&auto=format&fit=crop",
  blog4:       "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=600&q=80&auto=format&fit=crop",
  blog5:       "https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?w=600&q=80&auto=format&fit=crop",
  blog6:       "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600&q=80&auto=format&fit=crop",
  about:       "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1000&q=80&auto=format&fit=crop",
  // Page hero images — each page gets a unique hero (editable in Sanity CMS)
  heroFleet:   "https://images.unsplash.com/photo-1540962351504-03099e0a754b?w=1800&q=85&auto=format&fit=crop",
  heroDest:    "https://images.unsplash.com/photo-1601581875309-fafbf2d3ed3a?w=1800&q=85&auto=format&fit=crop",
  heroRoutes:  "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?w=1800&q=85&auto=format&fit=crop",
  heroHotels:  "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1800&q=85&auto=format&fit=crop",
  heroSafety:  "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1800&q=85&auto=format&fit=crop",
  heroAbout:   "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1800&q=85&auto=format&fit=crop",
  heroContact: "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=1800&q=85&auto=format&fit=crop",
  heroBlog:    "https://images.unsplash.com/photo-1504512485720-7d83a16ee930?w=1800&q=85&auto=format&fit=crop",
  spetses:     "https://images.unsplash.com/photo-1534447677768-be436bb09401?w=800&q=80&auto=format&fit=crop",
  zakynthos:   "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=800&q=80&auto=format&fit=crop",
  kefalonia:   "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?w=800&q=80&auto=format&fit=crop",
  patmos:      "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=800&q=80&auto=format&fit=crop",
  skiathos:    "https://images.unsplash.com/photo-1504512485720-7d83a16ee930?w=800&q=80&auto=format&fit=crop",
  hydra:       "https://images.unsplash.com/photo-1597466599360-3b9775841aec?w=800&q=80&auto=format&fit=crop",
  kos:         "https://images.unsplash.com/photo-1623016216287-a3b50d6b0fca?w=800&q=80&auto=format&fit=crop",
  lefkada:     "https://images.unsplash.com/photo-1534447677768-be436bb09401?w=800&q=80&auto=format&fit=crop",
};

// Destination image lookup: CMS (dests) -> IMG fallback -> generic. `dests`
// is the runtime DESTS array ([{ name, slug, img }]); `imgMap` defaults to the
// shared IMG so callers that already use IMG need only pass `dests`.
// Name-lookup shared by the hero renderer (via destImg below) AND the JSON-LD
// image chain (jsonld.js) — one place-resolution, display and markup cannot
// drift on WHICH destination a name means.
export function destByName(name, dests = []) {
  return dests.find(x => x && x.name === name) || null;
}

export function destImg(name, dests = [], imgMap = IMG) {
  const d = destByName(name, dests);
  if (d?.img) return d.img.split("?")[0] + "?w=200&h=200&q=80&fit=crop";
  const k = (name||"").toLowerCase().replace(/\s+/g,"");
  const key = imgMap[k] ? k : Object.keys(imgMap).find(x => x.toLowerCase() === k);
  const url = key ? imgMap[key] : imgMap.island;
  return url ? url.split("?")[0] + "?w=200&h=200&q=80&fit=crop" : "";
}

// Resolve the TARGET destination for a route so its image (card) / heroImage (hero)
// can drive the route card + hero instead of a stock placeholder. from/to are free
// text + slug "athens-<dest>", with NO reference — match by slug-endteil first, then
// by name (case-insensitive); always the destination (to), never the origin (from).
// Returns null when no destination matches; callers fall back to the prior behaviour.
// `dests` is the runtime DESTS array.
export function destForRoute(route, dests = []) {
  if (!route) return null;
  const tail = String(route.slug || "").replace(/^athens-/i, "").trim().toLowerCase();
  const toName = String(route.to || "").trim().toLowerCase();
  return (tail && dests.find(d => (d.slug || "").toLowerCase() === tail))
    || dests.find(d => (d.name || "").trim().toLowerCase() === toName)
    || null;
}

// Lowest finite positive indicative price for a from->to pair. `routes` is the
// runtime SEO_ROUTES array ([{ from, to, prices }]). Returns null when no
// route / no valid price.
export function getRoutePriceMin(from, to, routes = []) {
  const route = routes.find(r => r.from === from && r.to === to);
  if (!route?.prices) return null;
  const valid = Object.values(route.prices).filter(p => typeof p === 'number' && p > 0 && Number.isFinite(p));
  return valid.length > 0 ? Math.min(...valid) : null;
}
